// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__BnHJf","item":"Slider_item__Whu0n","imgContain":"Slider_imgContain__pGocq","content":"Slider_content__53-J0"};